interface ENV {
  REACT_APP_API_URL: string;
}

export const ENV: ENV = (window as any).ENV || process.env;

if (!ENV.REACT_APP_API_URL) {
  throw new Error('REACT_APP_API_URL is not specified');
}



// WEBPACK FOOTER //
// ./src/env.ts